import L from "leaflet";

/** Leaflet 1.9 adds DOM focus listeners even while unbinding a tooltip. */
export function unbindLayerTooltip(layer: L.Layer): void {
  layer.unbindTooltip();
  const element = (layer as L.Path).getElement?.();
  if (element) {
    // Run after unbinding, otherwise its newly added handler retains a null tooltip.
    // Leaflet supports SVG elements and removing all handlers by event name;
    // its typings omit this handler-free overload.
    const offAll = L.DomEvent.off as unknown as (element: Element, events: string) => void;
    offAll(element, "focus blur");
  }
}
